import { axiosGet } from "../../common/js/axios-utility";

export const fetchPaylink = async (paylinkId: string) => {
    const { data } = await axiosGet(`paylink/2/${paylinkId}`);
    return data;
}
